import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="container-content">
        {/* Header */}
        <div className="max-w-2xl mb-12 md:mb-16">
          <p className="font-label font-medium text-label-lg text-primary-600 tracking-wide uppercase mb-3">
            Frequently Asked
          </p>
          <h2 className="font-heading text-display-md text-foreground-950 text-balance">
            Everything you need to know.
          </h2>
        </div>

        {/* FAQ list */}
        <div className="max-w-3xl space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className={`border transition-colors duration-300 ${
                openIndex === index
                  ? 'border-primary-300 bg-background-50'
                  : 'border-background-200/70 bg-background-50'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
              >
                <span className="font-heading font-semibold text-body-md text-foreground-950">
                  {item.question}
                </span>
                <span
                  className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full border transition-all duration-300 ${
                    openIndex === index
                      ? 'border-primary-500 bg-primary-500 text-background-50 rotate-45'
                      : 'border-background-300 text-foreground-500'
                  }`}
                >
                  <i className="ri-add-line text-sm" />
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-body-md text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 md:mt-12 p-6 md:p-8 bg-primary-50 border border-primary-200">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="font-heading font-semibold text-body-lg text-foreground-950 mb-1">
                Still have questions?
              </p>
              <p className="text-body-sm text-foreground-600">
                Our team is available Monday to Saturday, 8am to 6pm.
              </p>
            </div>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById('contact');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="bg-primary-500 text-background-50 hover:bg-primary-600 px-6 py-3 rounded-md text-body-sm font-label font-medium whitespace-nowrap transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}